// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__QWrb8","inner":"Form_inner__3OJCI","range":"Form_range__1j9aw","name":"Form_name__FVosr","actions":"Form_actions__3s8WF"};